import ButtonModel from '../../../model/ButtonModel';
import { DELETE, UPDATE } from '../../constants/actionsTypes';
import { BOT, BUTTON, ICE_BREAKER, WIDGET } from '../../constants/entityTypes';
import ChangeModel from '../../models/ChangeModel';
import changesQueueInstance from '../ChangesQueue';

type DEPENDENCY = typeof WIDGET | typeof ICE_BREAKER | typeof BOT;

class ButtonChangeManager<T extends ButtonModel> {
  changesQueue: typeof changesQueueInstance;
  entityType: string;

  constructor(changesQueue: typeof changesQueueInstance) {
    this.changesQueue = changesQueue;
    this.entityType = BUTTON;
  }

  update(
    beforeUpdate: T | null,
    afterUpdate: T,
    entityId: number,
    entityType: typeof WIDGET | typeof ICE_BREAKER = WIDGET,
    botId?: number,
  ) {
    const dependencies = new Map<DEPENDENCY, number>([
      [entityType, entityId],
      ...(botId ? [[BOT, botId] as [DEPENDENCY, number]] : []),
    ]);
    const change = new ChangeModel(
      this.entityType,
      UPDATE,
      beforeUpdate,
      afterUpdate,
      dependencies,
    );

    // Note: casting using as since I do not have time to refactor ChangesQueue to TS now.
    return this.changesQueue.addChange(change) as Promise<T>;
  }

  delete(
    button: T,
    entityId: number,
    entityType: typeof WIDGET | typeof ICE_BREAKER = WIDGET,
    botId?: number,
  ) {
    const dependencies = new Map<DEPENDENCY, number>([
      [entityType, entityId],
      ...(botId ? [[BOT, botId] as [DEPENDENCY, number]] : []),
    ]);
    const change = new ChangeModel(
      this.entityType,
      DELETE,
      button,
      null,
      dependencies,
    );

    return this.changesQueue.addChange(change) as Promise<T>;
  }
}

export default new ButtonChangeManager(changesQueueInstance);
